import DaisukiContentModel   from '@/models/services/website/DaisukiContentModel';
import WebsiteUserModel      from '@/models/services/website/WebsiteUserModel';
import WebsiteServiceModel   from '@/models/WebsiteServiceModel';
import doc                   from '@widesk-core/decorators/doc';

export default class DaisukiModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'daisukiContent': id;
		'daisukiContent.contentUrn': Urn;
		'daisukiContent.type': id;
		'user': id;
		'daisukiContent.tags[serviceUrn][tagReference]': id;
		'daisukiContent.tags[jts:registry:service:website][website_entertainment]': Urn;
	};

	private declare _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
	};

	static get path(): string {
		return 'daisukis/{?id}';
	}

	@doc.model(DaisukiContentModel) declare daisukiContent: DaisukiContentModel;
	@doc.model(WebsiteUserModel) declare user: WebsiteUserModel;
	@doc.string declare createdBy: string;
	@doc.string declare updatedBy: string;
	@doc.date declare createdAt: Dayjs;
	@doc.date declare updatedAt: Dayjs;
}
